var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ll-text-button-list"},_vm._l((_vm.buttonList),function(template_e,template_k){return _c('WsTextButton001',{key:template_k,attrs:{"leading-icon":template_e.icon,"leadingImage":template_e.img,"white":""},on:{"click":function($event){return _vm.$_buttonClick(template_e)}}},[_vm._v(" "+_vm._s(_vm.$t(template_e.name))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }